const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { selectLoop } from './-selectLoop';
export const Route = createFileRoute('/(app)/org/$org/')({
  staticData: {
    hideLoopNav: true
  },
  beforeLoad: async ({
    context: {
      queryClient,
      organizationId
    },
    params: {
      org
    }
  }) => {
    const loop = await selectLoop(queryClient, organizationId ?? '');
    if (!loop) return;
    throw redirect({
      to: '/org/$org/loop/$loopId',
      params: {
        org,
        loopId: loop.id
      },
      replace: true
    });
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});